import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock, Button, Col } from 'react-bootstrap';
import firebase from '../helpers/firebase';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import MemberCombobox from '../components/MemberCombobox';
import MakeUpTable from '../components/MakeUpTable';
import { connect } from 'react-redux';
import { TABLE_NAME } from '../helpers/constants';

const db = firebase.database();

class FormMakeUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: moment().format('YYYY-MM-DD'),
      hours: 8
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectedUserChange = this.handleSelectedUserChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {

    const { user, isLeaderOrAdmin } = this.props

    if (!isLeaderOrAdmin) {
      window.location.href = '/dashboard';
      return true;
    }
    this.admin = user;
  }


  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value}
    );
  }

  handleSelectedUserChange(newSelectedUserId) {
    this.setState({
      selectedUserId: newSelectedUserId,
      makeups: []
    });
    db.ref(`users/${newSelectedUserId}`).once('value')
      .then((userSnapshot) => {
        this.setState({selectedUser: userSnapshot.val()})
      })
  }

  handleDateChange(date, modifiers) {
    this.setState({date: moment(date).format('YYYY-MM-DD')});
  }

  handleSubmit(e) {
    e.preventDefault();
    const { date, hours, selectedUserId } = this.state
    const data = {
      date,
      hours,
      userId: selectedUserId,
      requestedBy: this.props.user
    };

    db.ref(TABLE_NAME.MAKEUPS).push(data).then(() => {
      window.location.href = '/admin';
    });
  }

  render() {

    const userCombobox = (
      <MemberCombobox
        onInputChange={this.handleSelectedUserChange}
        description={'Pick a user you wish to add Make-up day'}>
      </MemberCombobox>
    );

    if (!this.state.selectedUserId) {
      return (
        <form>
          <Col xs={12} md={6}>
            {userCombobox}
          </Col>
        </form>
      );
    }

    const dayPickerProps = {
      todayButton: 'Go to Today',
      enableOutsideDays: true,
      modifiers: {
        monday: { daysOfWeek: [1] },
      },
      disabledDays: {
        after: new Date()
      }
    };

    const { selectedUser, isLoading } = this.state
    return (
      <form>
        <Col xs={12} md={6}>
          {userCombobox}

          <FormGroup controlId="date">
            <ControlLabel>Happen Date</ControlLabel>

            <DayPickerInput
              value={this.state.date}
              className="form-control date"
              onDayChange={(date, modifiers) => this.handleDateChange(date, modifiers)}
              name="date"
              id="date"
              format="YYYY-MM-DD"
              dayPickerProps={dayPickerProps}
            />
            <HelpBlock>
              The date the guy works on hodiday
            </HelpBlock>
          </FormGroup>

          <FormGroup controlId="hours">
            <ControlLabel>Number of Hours</ControlLabel>
            <FormControl id="hours" name="hours" value={this.state.hours} onChange={this.handleInputChange} componentClass="select" placeholder="select">
              <option value="8">Full Day</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
            </FormControl>
            <HelpBlock>
              Hours he/she worked on holiday
            </HelpBlock>
          </FormGroup>
          <Button type="submit"
            bsStyle="success"
            disabled={isLoading}
            onClick={!isLoading ? this.handleSubmit : null}
          >
            {isLoading ? 'Submitting...' : 'Submit'}
          </Button>

        </Col>
        <Col xs={12} md={6}>
          <h2>Make-up Days {selectedUser ? `of ${selectedUser.name}` : ''}</h2>
          <MakeUpTable userId={this.state.selectedUserId}/>
        </Col>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, isLeaderOrAdmin } = state.auth;
  return { user, isLeaderOrAdmin };
}

export default connect(mapStateToProps)(FormMakeUp);



// WEBPACK FOOTER //
// ./src/page/FormMakeUp.js